import React, {Component} from 'react';
import Measure from 'react-measure';
import {grey500} from 'material-ui/styles/colors';
import {FormattedMessage} from 'react-intl';

const styles = {
  footer: {
    color: grey500,
    fontSize: '11px',
    margin: '0 1em 1em',
  },
};

class WidgetFooter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      height: -1,
    };
  }

  handleDimensionsChange = ({bounds, margin}) => {
    const heightWithMargin = bounds.height + margin.top + margin.bottom;
    if (this.state.height !== heightWithMargin) {
      this.setState({height: heightWithMargin});
      this.props.onHeightChange(heightWithMargin);
    }
  };

  render() {
    return (
      <Measure bounds margin onResize={this.handleDimensionsChange}>
        {({measureRef}) =>
          <div ref={measureRef} style={styles.footer}>
            <FormattedMessage
              id="numberOfAnswers"
              values={{count: this.props.answersCount}}
            />
          </div>
        }
      </Measure>
    );
  }
}

export default WidgetFooter;



// WEBPACK FOOTER //
// ./src/components/WidgetFooter/WidgetFooter.js